export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Details',
    pathname: '/',
    hash: '#details',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'Twitter',
    url: 'https://twitter.com/mmcfly545',
    icon: 'twitter',
  },
  {
    label: 'Figma',
    url: 'https://www.figma.com/@fancykat',
    icon: 'figma',
  },
  {
    label: 'Github',
    url: 'https://github.com/fancykat',
    icon: 'github',
  },
];
